import PdfEmbed from './PdfEmbed';

export default PdfEmbed;
